const ClearandRefresh = () => {
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim()
    document.cookie = `${name}=; Max-Age=0; path=/`
  })

  // Clear localStorage and sessionStorage
  localStorage.clear()
  sessionStorage.clear()
  let idleTime = 0

  // Increment the idle time every minute.
  setInterval(timerIncrement, 1000) // 1 minute

  function timerIncrement() {
    idleTime++
    if (idleTime > 15) {
      // 5 minutes
      // window.close() // Only works if this window was opened via script
      window.location.href = "about:blank"
      window.history.replaceState(null, "", "/")
    }
    // console.log(idleTime)
  }

  // Reset the idle timer on user activity
  ;["mousemove", "keypress", "click", "scroll"].forEach((evt) => {
    window.addEventListener(evt, () => (idleTime = 0))
  })
}

export { ClearandRefresh }
